// modal.service.ts
import { ApplicationRef, Injectable, Injector, Type, EnvironmentInjector, ComponentRef, createComponent } from '@angular/core';
import { DynamicModelComponent, ModelConfig } from '../common/dynamic-model/dynamic-model.component';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private modalCounter = 0;

  constructor(
    private injector: Injector,
    private appRef: ApplicationRef,
    private environmentInjector: EnvironmentInjector // <-- add this for standalone support
  ) {}

  open<T>(component: Type<T>, config: Partial<ModelConfig<T>> = {}): Subject<any> {
    this.modalCounter++;
    const uniqueId = `modal-${this.modalCounter}`;

    // Dynamically create the DynamicModelComponent (container for modal)
    const compRef = createComponent(DynamicModelComponent, {
      environmentInjector: this.environmentInjector
    });

    // Set modal inputs
    compRef.instance.componentType = component;
    compRef.instance.config = config || {};
    compRef.instance.modalId = uniqueId;
    compRef.instance.environmentInjector = this.environmentInjector; // Pass environmentInjector as @Input

    // Handle output
    const result$ = new Subject<any>();
    compRef.instance.onClose.subscribe((result: any) => {
      result$.next(result);
      result$.complete();
      // Cleanup
      this.appRef.detachView(compRef.hostView);
      compRef.destroy();
    });

    this.appRef.attachView(compRef.hostView);
    const domElem = (compRef.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    return result$;
  }
}
